const confirm = {
  group: {
    status: {
      enable: "Confirm enable this group?", //确认启用该群组吗？
      stop: "Confirm suspend this group?" //确认暂停该群组吗？
    }
  },
  message: {
    group: {
      del: "A total of {nummer} group will be deleted, please confirm！"//共将删除{nummer}个群组，请确认
    },
    sync:"Whether to determine the synchronization target:{account}?",
    toClose:"Confirm to close？",//是否确认关闭
    changeToPrice:"Change to current price ?",//确认修改成当前价格

  },
  title:{
    orderDetails:"order details",//订单详情
    price:"price confirmation",//价格确认

  }
};
export default confirm;



// WEBPACK FOOTER //
// ./src/api/lang/modules/confirm/confirm_en.js